// @ts-nocheck
import { PropsWithChildren } from 'react';
import { SerializedStyles } from '@emotion/react';

import '@material/web/progress/linear-progress.js';
import '@material/web/progress/circular-progress.js';

export interface ProgressProps extends PropsWithChildren {
  type: 'linear' | 'linear-primary' | 'circular';
  buffer?: number;
  value?: number;
  max?: number;
  size?: 'small' | 'medium' | 'large';
  indeterminate?: boolean;
  fourColor?: boolean;
  emotionCss?: SerializedStyles;
}

export const Progress = ({
  type,
  buffer = 1,
  value = 0,
  max = 1,
  size = 'medium',
  indeterminate,
  fourColor,
  emotionCss,
}: ProgressProps) => {
  const linearPrimaryCss = {
    '--md-linear-progress-active-indicator-color':
      'var(--md-sys-light-primary)',
    '--md-linear-progress-active-indicator-height': '4px',
    '--md-linear-progress-track-color': 'var(--md-ref-primary-90)',
    '--md-linear-progress-track-shape': '4px',
  };

  const sizeTokens: Record<string, React.CSSProperties> = {
    small: { '--md-circular-progress-size': '24px' },
    medium: { '--md-circular-progress-size': '48px' },
    large: { '--md-circular-progress-size': '72px' },
  };

  const emotionCssVariant =
    type === 'linear-primary' ? linearPrimaryCss : emotionCss;

  const props = {};
  if (indeterminate) {
    props.indeterminate = true;
  }
  if (fourColor) {
    props['four-color'] = true;
  }
  if (value) {
    props.value = value;
  }
  if (max) {
    props.max = max;
  }
  if (buffer) {
    props.buffer = buffer;
  }

  if (type === 'linear' || type === 'linear-primary') {
    return (
      <div css={emotionCssVariant} className="rk-progress-container">
        <md-linear-progress
          className="rk-progress rk-linear-progress"
          {...props}
        ></md-linear-progress>
      </div>
    );
  }

  if (type === 'circular') {
    return (
      <div
        css={emotionCss}
        className="rk-progress-container"
        style={sizeTokens[size]}
      >
        <md-circular-progress
          className="rk-progress rk-circular-progress"
          {...props}
        ></md-circular-progress>
      </div>
    );
  }
};
